const StartPageParallax = (function () {
  const $win = $(window);
  const foregroundToBackgroundRatio = 3;
  const crisisBannerHeight = getCrisisBannerHeight();

  function init() {
    setParallaxBehaviousOnHeaderMedia();
  }

  function setParallaxBehaviousOnHeaderMedia() {
    const hasParallax = $(".hero-block.js-has-parallax").length;
    if (!hasParallax) return;

    $(".hero-block.js-has-parallax")
      .children(".js-image-wrapper, .js-video-wrapper")
      .each(function () {
        const $element = $(this);

        $win.scroll(function () {
          const scrollTopBelowBanner = Math.max(
            $win.scrollTop() ?? 0 - crisisBannerHeight,
            0,
          );
          const topValue =
            scrollTopBelowBanner -
            scrollTopBelowBanner / foregroundToBackgroundRatio;

          $element.css({ top: topValue + "px" });
        });
      });
  }

  function getCrisisBannerHeight(): number {
    const crisisBannerWrapper = $(".crisis-information__banner-wrapper");
    if (!crisisBannerWrapper.length) return 0;

    return crisisBannerWrapper.innerHeight() ?? 0;
  }

  return {
    init,
  };
})();

export default StartPageParallax;
